<template>
    <div class="homePage clear">
      <div class="homePage_bg">

      </div>
      <div class="content_bg">

      </div>
            <div class="main">
                <div class="content">
                    <div class="home_titile">
                        <h3>同济大学邮箱注册</h3>
                        
                    </div>


                   <!--
                   <div class="detail">
                        <div class="detail_email">
                                <i class="iconfont icon-xuexiao"></i>
                                <h4>学校邮箱</h4>
                                <p class="title_dis">在册师生可注册并在有效期内使用一个具有个性化前缀的学校电子邮箱</p>
                            <div class="home_btn_link"> <el-button type="primary" @click="Coremail" >立即注册</el-button></div>
                        </div>
                        <div class="detail_margin">

                        </div>
                        <div class="detail_email">
                            <i class="iconfont icon-pengyou"></i>
                            <h4>校友邮箱</h4>
                                <p class="title_dis">所有曾经在本校学习或工作过的人员可注册并终身免费使用校友邮箱</p>
<div class="home_btn_link"><el-button type="primary"  >系统升级中</el-button></div>


                        </div>
                   </div>-->
                </div>
            </div>
    </div>
</template>

<script>
//import UserInfo_bg from "@/assets/img/bigBg/home_bg.jpg";
export default {
  name: "homePage",
  data() {
    return {

    };
  },

  methods: {
    officialEmail(){
      this.$router.push({ name: 'checkPhone'}) // 校友注册页面
       //this.$router.push({ name: 'Maintain'})  // 运维页面
    },
    Coremail(){
     // window.location.href="https://mail-mgmt.tongji.edu.cn:8081/index/regiter"
       window.location.href="https://mail.tongji.edu.cn/"

      // window.location.href="http://mail-mgmt.tongji.edu.cn:9000/oiosaml/saml/login"
      //window.location.href="http://mail-mgmt-test.tongji.edu.cn:9000/oiosaml/saml/login"
    },
  }
};
</script>

<style scoped>
.homePage {
  width: 100%;
}
.homePage_bg{
    width: 100%;
    height: 100vh;
    position: absolute;
    background: url("../../assets/img/bigBg/home_bg.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
          -webkit-filter: blur(5px);
            -moz-filter: blur(5px);
            -o-filter: blur(5px);
            -ms-filter: blur(5px);
            filter: blur(5px);
}
.content_bg{
    width: 680px;
    height: 464px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -340px;
    margin-top: -232px;
    background: #fff;
    opacity: 0.3;
    z-index: 0;
    border-radius: 5px;

}
.main {
  display: flex;
  width: 100%;
  min-width: 620px;
  height: 100vh;
  justify-content: center;
  align-items: center;

}
.main .content {
    width: 580px;
    height: 425px;
    padding: 5px 25px;
    position: relative;
    z-index: 1;
    background: #414749;
    border-radius: 5px;
}
.main .content .detail {
  display: flex;
  justify-content: space-between;
}
.detail_margin{
  width: 50px;
}
.detail_email {
  text-align: center;
  color: #fff;
}
.detail_email > .iconfont {
  font-size: 110px;
  color: #f9f9f9;
}
 .detail_email .title_dis{
  margin-top: 20px;
  line-height: 25px;
  font-size: 14px;
  width: 225px;
}
.home_titile h3 {
  font-weight: 600;
  font-size: 28px;
  color: #fff;
  text-align: center;
  margin-top: 10px;
}

.home_btn_link button{
  width: 225px;
  margin-top: 20px
}
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue